import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';

import { AgGridModule } from 'ag-grid-angular';

import { EntityList } from '../../objects/entity-list';
import { ContractService } from '../../service/entity-services/contract.service';
import { Contract } from '../../objects/contract';

import * as contractColumns from '../../shared/entity-columns/contract-columns';

// Version column for archived contracts
const colVersion = {
  colId: 'version',
  headerName: 'Version',
  field: 'version',
  width: 100,
  sortable: true,
  valueFormatter: (params: any) => params.value ? `v${params.value}` : 'v1'
};

@Component({
  selector: 'app-archived-contracts-list',
  templateUrl: './archived-contracts-list.component.html',
  styleUrls: ['./archived-contracts-list.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    AgGridModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatGridListModule,
    MatDividerModule,
    MatSidenavModule
  ]
})
export class ArchivedContractsListComponent extends EntityList implements OnInit, OnDestroy {
  private router = inject(Router);

  archivedContractCols: any[] = [
    colVersion,
    contractColumns.colContractId,
    contractColumns.colContractName,
    contractColumns.colContractStatus,
    contractColumns.colContractParty,
    contractColumns.colType,
    contractColumns.colContractExpirationDate,
    contractColumns.colContractDepartment,
    contractColumns.colLegalEntity,
    contractColumns.colSites
  ];

  archivedContractList: Contract[] = [];
  private subscription?: Subscription;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.subscription = this.contractService.archivedContracts$.subscribe(contracts => {
      this.archivedContractList = contracts;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  onCellClicked(event: any): void {
    if (event.data?.contractNum) {
      this.router.navigate(['/securehome/contract', event.data.contractNum]);
    }
  }

  onGridReady(params: any): void {
    this.gridApi = params.api;
    this.columnApi = params.api;
  }
}
